import React, {useEffect} from 'react'
import Image from "next/image";
import {Col, Container, Row} from 'reactstrap'
import {getImageUrl} from "../../services/image";
import {useLazyQuery} from "@apollo/client";
import CAMPER_SEARCH from "../../graphql/queries/camperSearch";
import withApollo from "../../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";
import pageData from '../../data/camper-rental.json'
import SearchBar from "../../components/Camper/SearchBar";
import LargeScreenComponent from "../../components/LargeScreenComponent";
import Icon from "../../components/Icon";
import SmallScreenComponent from "../../components/SmallScreenComponent";
import CardCamper from "../../components/Camper/CardCamper";
import {useRouter} from "next/router";

const seoIdToLocation = (seoId) => {
    switch (seoId) {
        case 'engeland':
            return 'London';
        case 'schotland':
            return 'Edinburgh';
        default:
            return 'Dublin';
    }
}

const Destination = () => {
    const router = useRouter();
    const [availableCampers, setAvailableCampers] = React.useState([]);

    const [searchCampers, {loading}] = useLazyQuery(CAMPER_SEARCH, {
        onCompleted: (data) => setAvailableCampers(data.CamperAvailability.campers)
    });

    useEffect(() => {
        const {destination, inleverdatum, inleverlocatie, ophaaldatum} = router.query;
        if (destination && inleverdatum && inleverlocatie && ophaaldatum) {
            searchCampers({
                variables: {
                    pickupCountry: destination,
                    pickupDateTime: `${ophaaldatum} 11:00`,
                    dropOffCity: inleverlocatie,
                    dropOffDateTime: `${inleverdatum} 11:00`,
                }
            });
        }
    }, [router.query])

    return (
        <React.Fragment>
            <section className="d-flex align-items-center dark-overlay dark-overlay-gradient overflow-none">
                <Image
                    src={getImageUrl('visitscotland_28424747634.jpg')}
                    layout="fill"
                    className="bg-image"
                    alt="Cottage Centre campers"
                    priority={true}
                />

                <Container className="py-md-5 mt-4 text-white z-index-20">
                    <div className="text-center text-lg-left">
                        <p className="subtitle letter-spacing-4 mb-2 text-green-light text-shadow d-none d-lg-block">
                            NATUUR • HISTORIE • CULTUUR
                        </p>
                        <h1 className="font-weight-bold text-shadow homepage-header-h1">
                            Ervaar Groot-Brittannië & Ierland vanuit uw camper
                        </h1>
                    </div>

                    <SearchBar />

                </Container>
            </section>

            <section className="py-3 bg-gray-100">
                <Container>
                    <Row className="mb-5">
                        <Col md="8">
                            {!loading && availableCampers &&
                            <h2>{availableCampers.length} Beschikbare campers</h2>
                            }

                            {!loading && !availableCampers &&
                            <h2>Geen beschikbare campers</h2>
                            }
                        </Col>
                        <Col
                            md="4"
                            className="d-md-flex align-items-center justify-content-end"
                        >
                        </Col>
                    </Row>
                    <Row>
                        {loading &&
                        <Col>
                            <div className="loader"></div>
                        </Col>
                        }

                        {!loading && availableCampers && availableCampers.map((camper) => {
                            return (
                                <Col
                                    key={camper.type}
                                    lg="4"
                                    sm="6"
                                    className="mb-4 hover-animate"
                                >
                                    <CardCamper
                                        camper={camper}
                                        pickupLocation={seoIdToLocation(router.query.destination)}
                                        dropOffLocation={router.query.inleverlocatie}
                                        pickupDate={router.query.ophaaldatum}
                                        dropOffDate={router.query.inleverdatum}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </Container>
            </section>

            {pageData.topBlocks &&
            <>
                <LargeScreenComponent>
                    <section className="py-3">
                        <Container fluid>
                            <Row className="bg-gray-100">
                                {pageData.topBlocks.blocks.map(block =>
                                    <Col
                                        key={block.title}
                                        lg="3"
                                        className="my-3"
                                    >
                                        <Row>
                                            <Col xs={2}>
                                                <div className="icon-rounded">
                                                    <Icon
                                                        icon={block.icon}
                                                        className="text-primary w-2rem h-2rem"
                                                    />
                                                </div>
                                            </Col>
                                            <Col xs={10}>
                                                <div className="px-0 px-lg-3 pl-3">
                                                    <h2 className="h5">{block.title}</h2>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                )}
                            </Row>
                        </Container>
                    </section>
                </LargeScreenComponent>
                <SmallScreenComponent>
                    <section className="py-2 pr-2">
                        <Container fluid>
                            <Row className="">
                                {pageData.topBlocksMobile.blocks.map(block =>
                                    <Col
                                        key={block.title}
                                        xs="3"
                                        className="text-center p-0"
                                    >
                                        <Icon
                                            icon={block.icon}
                                            className="text-primary"
                                        />
                                        <div className="">
                                            <span className="mobile-usp ml-1 mr-1 mt-1">{block.title}</span>
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </Container>
                    </section>
                </SmallScreenComponent>
            </>
            }
        </React.Fragment>

    )
}

Destination.getInitialProps = async () => {
    return {
        nav: {
            light: true,
            classes: "shadow",
            color: "white",
        },
        title: "Camper verhuur"
    }
}

export default withApollo(Destination,
    {
        getDataFromTree
    }
);
